var React = require('react');

function SortUp (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M7 3.824L5.487 5.306a1.027 1.027 0 0 1-1.438 0 .988.988 0 0 1 0-1.415L8.003 0l3.948 3.887a.988.988 0 0 1 0 1.415 1.027 1.027 0 0 1-1.438 0L9 3.82v11.179a1 1 0 1 1-2 0V3.824z"}));
}

SortUp.defaultProps = {"viewBox":"0 0 16 16"};

module.exports = SortUp;

SortUp.default = SortUp;
